import axios from 'axios';
import { ENDPOINTS } from 'config/endpoints';
import { cookies, cookieDomain } from 'constants/crono-cookie';
import { FeConstants } from 'constants/FeConstants';
import { isLocal } from 'utils/uiHelpers';

const CSRF_COOKIE_EXPIRY_MS = 16 * 60 * 60 * 1000;

const setCsrfCookie = (name: string, value: string) => {
  cookies.set(name, value, {
    domain: cookieDomain,
    path: '/',
    expires: new Date(Date.now() + CSRF_COOKIE_EXPIRY_MS),
    sameSite: 'none',
    secure: true,
  });
};

export const getCsrfCookieName = () =>
  isLocal() ? FeConstants.cronoCsrfLocalCookie : FeConstants.cronoCsrfCookie;

export const getCsrfToken = (): string | undefined =>
  cookies.get(getCsrfCookieName());

let inFlight: Promise<boolean> | null = null;

export const refreshCsrfToken = (): Promise<boolean> => {
  if (inFlight) return inFlight;

  const isLocalEnv = isLocal();
  inFlight = axios(
    `${process.env.VITE_APP_BE_URL}/${ENDPOINTS.csrf.main}?isFromLocal=${isLocalEnv}`,
    {
      method: 'GET',
      withCredentials: true,
      headers: { 'X-Request-Source': 'FE App' },
    },
  )
    .then((csrf) => {
      const localCsrf = csrf?.headers['xsrf-token-local'];
      //Dev.api.crono.one sends 2 csrf tokens, one for local and one for dev, this is for the extension that looks for dev ones to work
      if (localCsrf && isLocalEnv) {
        setCsrfCookie(FeConstants.cronoCsrfLocalCookie, localCsrf);
        return true;
      }
      //New way to set the csrf from the headers (Dev or prod one)
      if (csrf?.headers?.['xsrf-token']) {
        setCsrfCookie(FeConstants.cronoCsrfCookie, csrf.headers['xsrf-token']);
        return true;
      }
      //Kept for backCompatibility with the old API
      if (csrf?.data?.data) {
        setCsrfCookie(
          isLocalEnv
            ? FeConstants.cronoCsrfLocalCookie
            : FeConstants.cronoCsrfCookie,
          csrf.data.data,
        );
        return true;
      }
      return false;
    })
    .catch((error) => {
      console.error(error);
      return false;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};
